// extracted by css-extract-rspack-plugin
export default {"SegmentedControl":"s3QlM","SegmentedControlLabel":"GpASm","SegmentedControl_Control":"rfGLn","SegmentedControlInput":"UVDLK","SegmentedControlIndicator":"fmlsQ"};